import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

export interface SimpleInputDialogData {
  title?: string;
  prompt?: string;
  initialValue?: string;
}

@Component({
  selector: 'app-simple-input',
  templateUrl: './simple-input.component.html',
  styleUrls: ['./simple-input.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    DragDropModule
  ]
})
export class SimpleInputComponent {
  inputText = '';

  constructor(
    public dialogRef: MatDialogRef<SimpleInputComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleInputDialogData
  ) {
    if (data?.initialValue) {
      this.inputText = data.initialValue;
    }
  }

  onOk(): void {
    this.dialogRef.close(this.inputText);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}   